var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.452,
    height: 23.452,
    viewBox: "0 0 23.452 23.452",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warning_icon",
    "data-name": "Warning icon",
    transform: "translate(-496.134 -247.774)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10367",
    "data-name": "Path 10367",
    d: "M221.725,185.984a11.726,11.726,0,1,1,11.726-11.726A11.726,11.726,0,0,1,221.725,185.984Z",
    transform: "translate(286.135 85.242)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3386",
    "data-name": "Rectangle 3386",
    width: 3.191,
    height: 11.168,
    rx: 1.595,
    transform: "translate(506.376 251.523)",
    fill: "#df676b"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_145",
    "data-name": "Ellipse 145",
    cx: 1.595,
    cy: 1.595,
    rx: 1.595,
    ry: 1.595,
    transform: "translate(506.376 264.286)",
    fill: "#df676b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningicon);
export default __webpack_public_path__ + "static/media/Warning icon.34a8281a684268adbeccf9462976ebea.svg";
export { ForwardRef as ReactComponent };